import { waitForDOMContentLoaded } from "../utils/async-utils";

AFRAME.registerSystem("teleporter-system", {
  init() {
    waitForDOMContentLoaded().then(() => {
      this.domContentLoadedButComponentsMayNotHave = true;
    });
    this.isTeleporting = false;

    this.el.sceneEl.addEventListener("userinputdevicechanged", () => this.cancelTeleport());
  },
  cancelTeleport() {
    this.gazeTeleporter.cancelTeleport();
    this.leftHandTeleporter.cancelTeleport();
    this.rightHandTeleporter.cancelTeleport();
  },
  tick() {
    if (!this.domContentLoadedButComponentsMayNotHave) return;
    if (!this.gotComponentReferences) {
      this.gotComponentReferences = true;
      this.gazeTeleporter = document.getElementById("gaze-teleport").components["teleporter"];
      this.leftHandTeleporter = document.getElementById("player-left-controller").components["teleporter"];
      this.rightHandTeleporter = document.getElementById("player-right-controller").components["teleporter"];
    }

    this.isTeleporting =
      this.gazeTeleporter.isTeleporting ||
      this.leftHandTeleporter.isTeleporting ||
      this.rightHandTeleporter.isTeleporting;
  }
});
